import { ListItemTextProps as MuiListItemTextProps } from '@mui/material/ListItemText/ListItemText';
import { forwardRef } from 'react';
import MuiListItemText from '@mui/material/ListItemText';
import Typography from '../Typography';

export interface ListItemTextProps extends MuiListItemTextProps {
  variant?: 'default' | 'pane-item';
}

const ListItemText = forwardRef<unknown, ListItemTextProps>((props, ref) => {
  const { variant, primary: defaultPrimary, ...other } = props;

  const primary =
    variant === 'pane-item' ? (
      <Typography component="span" className="MuiListItemText-primary">
        {defaultPrimary}
      </Typography>
    ) : (
      defaultPrimary
    );

  return (
    <MuiListItemText
      disableTypography={variant === 'pane-item'}
      primary={primary}
      ref={ref}
      {...{ ...other, variant }}
    />
  );
});

ListItemText.displayName = 'ListItem.Text';

export default ListItemText;
